import { render, staticRenderFns } from "./CollapsibleMenu.vue?vue&type=template&id=4d4254b4&"
import script from "./CollapsibleMenu.vue?vue&type=script&lang=js&"
export * from "./CollapsibleMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleMenu.vue?vue&type=style&index=0&id=4d4254b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports